// ── Tier Definitions ─────────────────────────────────────────
// Maps to product brief: Free / Pro ($99) / Elite ($299)

export const TIERS = {
  FREE: 'free',
  PRO: 'pro',
  ELITE: 'elite',
};

export const TIER_CONFIG = {
  [TIERS.FREE]: {
    name: 'Free',
    price: 0,
    label: 'Explorer',
    icon: '🔍',
    features: [
      'Delayed ticker (30s lag)',
      'Basic rug checks (Mint/Freeze)',
      'Signal marketplace (view only)',
      'Community access',
    ],
    limits: {
      tickerDelay: 30000,    // 30s delayed
      rugCheckDepth: 'basic', // mint/freeze only
      whaleAlerts: false,
      bossManSignals: false,
      bundleDetection: false,
      telegramAlerts: false,
      apiAccess: false,
    },
  },
  [TIERS.PRO]: {
    name: 'Pro',
    price: 99,
    label: 'Operator',
    icon: '⚡',
    features: [
      'Real-time ticker (zero lag)',
      'Full rug score algorithm',
      'Whale alerts (Top 100 wallets)',
      'Smart money convergence signals',
      'Signal history & analytics',
    ],
    limits: {
      tickerDelay: 0,
      rugCheckDepth: 'full',
      whaleAlerts: true,
      bossManSignals: false,
      bundleDetection: false,
      telegramAlerts: false,
      apiAccess: false,
    },
  },
  [TIERS.ELITE]: {
    name: 'Elite',
    price: 299,
    label: 'Boss Man',
    icon: '👑',
    features: [
      'Everything in Pro',
      'Boss Man signals (KOL wallet tracking)',
      'Jito bundle detection',
      'Telegram & webhook alerts',
      'Full API access',
      'Priority support',
    ],
    limits: {
      tickerDelay: 0,
      rugCheckDepth: 'full',
      whaleAlerts: true,
      bossManSignals: true,
      bundleDetection: true,
      telegramAlerts: true,
      apiAccess: true,
    },
  },
};

// Helper: check if a tier has access to a feature
export const hasAccess = (userTier, feature) => {
  const config = TIER_CONFIG[userTier];
  if (!config) return false;
  return config.limits[feature] ?? false;
};

// Tier hierarchy for comparison
const TIER_RANK = { [TIERS.FREE]: 0, [TIERS.PRO]: 1, [TIERS.ELITE]: 2 };
export const isAtLeast = (userTier, requiredTier) =>
  (TIER_RANK[userTier] ?? 0) >= (TIER_RANK[requiredTier] ?? 0);
